/** 🌍 GLOBAL STANDART KOD (TÜM PROJELER İÇİN GEÇERLİDİR)
 * GLOBAL UI — tek kaynak qubepro-core; yalnız resmî UI senkronuyla dağıtılır.
 * Audit, yetki ve kayıt işlemleri bu sunum katmanına girmez.
 */
import { Modal, type ModalProps } from './Modal';
import './FormModal.css';

export function FormModalSurface({
    contentClassName, overlayClassName, closeOnOverlayClick = false, ...props
}: ModalProps) {
    return <Modal {...props}
        contentClassName={[...(contentClassName ?? '').split(/\s+/).filter((name) => name && name !== 'modal-content'), 'qubepro-form-modal'].join(' ')}
        overlayClassName={['qubepro-form-modal-overlay', overlayClassName].filter(Boolean).join(' ')}
        closeOnOverlayClick={closeOnOverlayClick} />;
}
